// config/public/production.js
module.exports = {
  proxy_api_host: process.env.PROXY_API_HOST,
  rechat_host: process.env.RECHAT_HOST,
  rechat_url: process.env.RECHAT_URL,
  stripe_pk: process.env.STRIPE_PK,
  google: {
    api_key: process.env.GOOGLE_API_KEY
  }
}


//////////////////
// WEBPACK FOOTER
// ./config/public/production.js
// module id = 172
// module chunks = 0